import React from "react";
import styles from "./styles.module.scss";

export const Home = () => {
  return (
    <div className={styles.Home}>
      <section className={styles.AboutMe}>
        <div className={styles.Content}>
          <h2>About Me</h2>
          <p>
            Hey 👋 My name is Zyad (Pronounced Zee-Yad). I'm a software engineer
            and entrepreneur based in San Francisco, CA. I'm a proud Egyptian 🇪🇬
            who was born & raised by an amazing family in the Seattle area.
          </p>
          <h2>What I'm Currently Doing</h2>
          <p>
            I'm currently the co-founder of{" "}
            <a
              href="https://runreplay.com/"
              className={styles.Link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Replay
            </a>
            . Replay makes life something that you can search. We're building a
            video wearable that captures important memories and makes them
            searchable with AI.
          </p>
          <h2>My Background</h2>
          <p>
            I've always loved building things that people use. I've worked on
            many successful projects & companies and have met a lot of great
            people along the way. Before Replay, I went through YC's W25 batch
            with CopyCat, where we spent a year pivoting between browser agents,
            RPA, dermatology, and a handful of other ideas. Before that, I was
            the co-founder of{" "}
            <a
              href="https://www.joinplatter.com/"
              className={styles.Link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Platter
            </a>
            , a company that provided websites and mobile apps to hundreds of
            mom & pop restaurants across the west coast. I've built many other
            cool things people used and I've also previously been a software
            engineer at{" "}
            <a
              href="https://www.okta.com/"
              className={styles.Link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Okta
            </a>
            {" & "}
            <a
              href="https://www.verkada.com/"
              className={styles.Link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Verkada
            </a>
            .
          </p>
          <h2>My Education</h2>
          <p>
            I went to college at the University of Washington, where I earned a
            Bachlor's in Computer Science with a Minor in Entrepreneurship.
            While there, I built Course Finder, the most used course research
            platform at UW while I was there, powering the course research
            process for 10,000 students every quarter.
          </p>
        </div>
        <div className={styles.ImageContainer}>
          <img
            src={require("../../assets/profile.png")}
            alt="Profile"
            className={styles.ProfileImage}
          />
        </div>
      </section>
    </div>
  );
};
